import React from "react";
import { Alert, Tooltip } from "@paylixecommerce/shared/components";
import { Switch, Text } from "components/fields";
import config from "constants/config";
import useMobile from "../../../../../../../../hooks/useMobile";
import { Select } from "../../../../../../../../components";

import "./index.scss";


export default ({ form, isVariant }) => {

	const isMobile = useMobile();

	return <div className="product-form-main-back pb-3">

		{!isVariant && form.values.type !== "SUBSCRIPTION" && <div className="mb-3 position-relative">
			{isMobile ?
				<div className="mb-3">
					<label className="paylixecommerce-label">Type</label>
					<Select
						size="large"
						value={form.values.pay_what_you_want}
						className={form.errors.pay_what_you_want && form.touched.pay_what_you_want ? 'error' : ''}
						onChange={form.handleChange("pay_what_you_want")}
						options={config.PAYMENT_TYPE_OPTIONS}
					/>
				</div>
				:
				<div className={`type-widget ${form.errors.pay_what_you_want && form.touched.pay_what_you_want ? 'error' : ''}`}>
					<div>
						{config.PAYMENT_TYPE_OPTIONS.map(({ value, label }) =>
							<button
								style={isVariant ? { width: "25%" } : {}}
								key={label}
								type="button"
								className={(`${form.values.pay_what_you_want}` === value) ? "active" : ""}
								onClick={() => {
									form.setFieldValue("pay_what_you_want", value);
								}}
							>
								{label}
							</button>
						)}
					</div>
					{form.errors.pay_what_you_want && form.touched.pay_what_you_want && <span className="type-widget-error">Type is required</span>}
				</div>
			}
		</div>
		}

		{`${form.values.pay_what_you_want}` === '1' && !isVariant && form.values.type !== "SUBSCRIPTION" &&
			<div className="paylixecommerce-note-big mb-3">
				With pay what you want product, customers can pay whatever amount they'd like.
				This can be a fixed price, a donation, or a custom payment based on their budget and your value for the product.
				You can also set a minimum price if you prefer.
				It's a flexible and creative way for your clients to support the you and get access to unique and valuable items.
			</div>
		}

		<div className="price-input">
			<label className="paylixecommerce-label">
				{isVariant ? "Currency" : `${`${form.values.pay_what_you_want}` === '1' ? 'Minimum ': ''}Price`}
				<Tooltip
					tooltipText="You can show the price of your product converted into any specific cryptocurrency by updating your store design settings."
					name="multi-currency-tooltip"
				>
					<span>
							<i className="fa-regular fa-info-circle mx-1" style={{ color: "var(--black9)", fontSize: 12 }} />
					</span>
				</Tooltip>
			</label>
			<div className="d-flex">
				<select className={`paylixecommerce-select ${isVariant ? 'variant-price' : ''}`} value={form.values.currency} name="currency" placeholder="Currency" onChange={(option) => { form.handleChange("currency")(option) }}>
					{Object.values(config.CURRENCY_OPTIONS).map(({ title, key }) => (
						<option value={key} key={key}>{title}</option>
					))}				</select>
				{isVariant ? null : <Text
					wrapperClassName="w-100"
					name="price"
					placeholder="Price"
					className="w-100"
					type="number"
					step="0.01"
					lang="en"
					{...form}
				/>}
			</div>
		</div>

		{+form.values.price === 5 && form.values.currency === "USD" ?
			<Alert size="small" className="mb-3 w-100" variant="purple" title="Info" >
				By setting your product price to USD 4.99 instead, you'll avoid our 0.25 fee.
			</Alert>
			: null
		}

		{`${form.values.pay_what_you_want}` !== '1' &&
			<div>
				<Switch name="price_discount_enabled" left label="Add Price Discount " note="Set your product discount here." {...form} />

				{form.values.price_discount_enabled ?
					<div className="mt-3 position-relative">
						<div className="paylixecommerce-input-prefix" style={{ top: 0 }}>
							%
						</div>
						<Text name="price_discount" type="number" lang="en" placeholder="ex: 10%" {...form} />
					</div> :
					null
				}
			</div>
		}
	</div>
}